import React, { useEffect } from 'react'
import { useState } from 'react'
import Modal from '../../controls/Modal'
import LodingButton from '../../controls/LodingButton'
import { useFormik } from 'formik'
import Input from '../../controls/Input'
import * as yup from 'yup'
import { json, useParams } from 'react-router-dom'
import { GetEType } from '../../../configurations/enums/EType'
import { useToast } from '../../controls/Toast/ToastService'
import { MdBloodtype, MdDriveFileRenameOutline } from 'react-icons/md'
import { FaAddressCard, FaNotesMedical, FaPhone } from 'react-icons/fa'
import { GiWeightScale } from 'react-icons/gi'
import { FaPerson } from 'react-icons/fa6'
import { MdOutlineLocalPhone } from "react-icons/md";
import { GetEGender } from '../../../configurations/enums/EGender'
import Select from '../../controls/Select'
import { BsGenderAmbiguous } from 'react-icons/bs'
import Datepicker from 'react-tailwindcss-datepicker'
import moment from 'moment'
import useAuth from '../../../configurations/auth/publicUsers/useAuth'


const schema = yup.object().shape({
    patientName: yup.string().required("Patient Name is required."),
    mobile: yup.string().matches(/^\d{10}$/, 'Mobile number must be exactly 10 digits').required('Mobile number is required'),
    patientAddress: yup.string().min(3, "Address must minimum 3 characters").required("Patient Address is required."),
    weight: yup.string().matches(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/, 'Should be digit.').required("Weight is required."),
    age: yup.string().matches(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/, 'Should be digit.').required("Age is required."),
    gender: yup.string().required("Gender is required."),
    onDate: yup.string().required("Date is required."),
})

export default function AddOpdOnline({ isOpen, setIsOpen, addOpdOnline, loding, centerId, centerData, title = "Add New OPD" }) {
    const toast = useToast()
    const { authentication } = useAuth()
    const TODAYS_DATE = new Date()
    const MAX_DATE = new Date();
    MAX_DATE.setDate(MAX_DATE.getDate() + parseInt(centerData.byDaysCount));
    const [value, setValue] = useState({
        startDate: TODAYS_DATE,
        endDate: TODAYS_DATE
    });
    const { values, handleBlur, handleChange, handleSubmit, errors, touched, isValid, setValues } = useFormik({
        initialValues: {
            opdCenterId: centerId,
            patientName: "",
            mobile: authentication.isLogin ? authentication.data.phoneNo : "",
            bloodGroup: "N/A",
            weight: 0,
            age: "",
            gender: 0,
            note: "",
            patientAddress: "",
            onDate: TODAYS_DATE
        },
        validationSchema: schema,
        onSubmit(val) {
            addOpdOnline(val, setValues)
        }
    })
    useEffect(() => {
        if (centerId) {
            setValues({ ...values, opdCenterId: centerId })
        }
    }, [centerId])

    useEffect(() => {
        if (value.startDate)
            setValues(pre => ({ ...pre, onDate: moment(new Date(value.startDate)).format("MM/DD/YYYY") }))
        else {
            setValues(pre => ({ ...pre, onDate: TODAYS_DATE }))
            setValue({
                startDate: TODAYS_DATE,
                endDate: TODAYS_DATE
            })
        }

    }, [value.startDate])
    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={title}>
            <form onSubmit={handleSubmit}>
                <div class="p-6 space-y-6">
                    <div class="grid grid-cols gap-6">
                        {centerData?.opdType == 1 &&
                            <div class="col-span-12">
                                <label class="block mb-2 text-sm font-medium text-gray-900">Select Appointment Date (दिखाने की तारीख)</label>
                                <Datepicker
                                    minDate={TODAYS_DATE}
                                    maxDate={MAX_DATE}
                                    popoverDirection='down'
                                    useRange={false}
                                    asSingle={true}
                                    displayFormat="DD/MM/YYYY"
                                    readOnly={true}
                                    primaryColor={"sky"}
                                    value={value}
                                    onChange={newValue => setValue(newValue)}
                                    inputClassName="outline-blue-400 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 w-full p-2.5"
                                />
                                {errors.onDate && <p className='text-red-600 text-xs'>{errors.onDate}</p>}
                            </div>
                        }
                        <div class="col-span-12 sm:col-span-6">
                            <label for="patientName" class="block mb-2 text-sm font-medium text-gray-900">Patient Name (मरीज का नाम)</label>
                            <Input placeholder="Patient Name"
                                id="patientName"
                                Icon={<MdDriveFileRenameOutline className='text-green-600 text-lg' />}
                                value={values.patientName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.patientName && touched.patientName}
                            />
                            {errors.patientName && touched.patientName && <p className='text-red-600 text-xs'>{errors.patientName}</p>}
                        </div>

                        <div class="col-span-12 sm:col-span-6">
                            <label for="mobile" class="block mb-2 text-sm font-medium text-gray-900 ">Mobile (मोबाइल नंबर)</label>
                            {authentication.isLogin ?
                                <div class="relative w-full pt-2  cursor-not-allowed flex items-center">
                                    <div class="ps-3 pointer-events-none">
                                        <MdOutlineLocalPhone className="text-blue-600 text-xl" />
                                    </div>
                                    <div class="pl-2 text-xl">{values.mobile}</div>
                                </div>
                                : <Input placeholder="Mobile"
                                    id="mobile"
                                    Icon={<MdOutlineLocalPhone className="text-blue-600 text-lg" />}
                                    value={values.mobile}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isError={errors.mobile && touched.mobile}
                                />}
                            {errors.mobile && touched.mobile && <p className='text-red-600 text-xs'>{errors.mobile}</p>}
                        </div>
                        <div class="col-span-12">
                            <label for="patientAddress" class="block mb-2 text-sm font-medium text-gray-900 ">Patient Address (मरीज का पता)</label>
                            <Input placeholder="Patient Address"
                                id="patientAddress"
                                Icon={<FaAddressCard className='text-brand-500 text-lg' />}
                                value={values.patientAddress}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.patientAddress && touched.patientAddress}
                            />
                            {errors.patientAddress && touched.patientAddress && <p className='text-red-600 text-xs'>{errors.patientAddress}</p>}
                        </div>
                        <div class="col-span-12 sm:col-span-6">
                            <label for="age" class="block mb-2 text-sm font-medium text-gray-900">Age (आयु)</label>
                            <Input placeholder="Age"
                                id="age"
                                type="text"
                                Icon={<FaPerson className='text-teal-600 text-lg' />}
                                value={values.age}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.age && touched.age}
                            />
                            {errors.age && touched.age && <p className='text-red-600 text-xs'>{errors.age}</p>}
                        </div>

                        <div class="col-span-12 sm:col-span-6">
                            <label for="gender" class="block mb-2 text-sm font-medium text-gray-900">Gender</label>
                            <Select
                                Icon={<BsGenderAmbiguous className='text-orange-600 text-lg' />}
                                id="gender"
                                value={values.gender}
                                onChange={handleChange}
                                onBlur={handleBlur}>
                                {GetEGender.EGender.map((items, index) =>
                                    <option value={items.Id}>{items.Name}</option>
                                )}
                            </Select>
                        </div>
                        <div className="col-span-12 sm:col-span-6">
                            <label htmlFor="bloodGroup" className="block mb-2 text-sm font-medium text-gray-900 ">
                                Blood Group (ब्लड ग्रुप)
                            </label>
                            <Select
                                Icon={<MdBloodtype className='text-red-600 text-lg' />}
                                id="bloodGroup"
                                name="bloodGroup"
                                value={values.bloodGroup}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.bloodGroup && touched.bloodGroup}
                            >
                                <option value="N/A">N/A</option>
                                <option value="A+">A+</option>
                                <option value="A-">A-</option>
                                <option value="B+">B+</option>
                                <option value="B-">B-</option>
                                <option value="AB+">AB+</option>
                                <option value="AB-">AB-</option>
                                <option value="O+">O+</option>
                                <option value="O-">O-</option>
                            </Select>
                            {errors.bloodGroup && touched.bloodGroup && (
                                <p className="text-red-600 text-xs">{errors.bloodGroup}</p>
                            )}
                        </div>

                        <div class="col-span-12 sm:col-span-6">
                            <label for="note" class="block mb-2 text-sm font-medium text-gray-900">Note (कोई परेशानी या जानकरी लिखिए)</label>
                            <Input placeholder="Note"
                                id="note"
                                Icon={<FaNotesMedical className='text-orange-300 text-lg' />}
                                value={values.note}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.note && touched.note}
                            />
                            {errors.note && touched.note && <p className='text-red-600 text-xs'>{errors.note}</p>}
                        </div>
                    </div>
                </div>
                <div class="flex items-center p-6 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b">
                    {!loding ?
                        <button type="submit" className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid}>Create</button>
                        : <LodingButton text="Wait.." />
                    }
                </div>
            </form>
        </Modal>

    )
}

